import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService, error_msg } from '../services/api.service';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrl: './errorpage.component.scss',
})
export class ErrorpageComponent implements OnInit, AfterViewInit {
  errorMsg: error_msg = null;
  isExternal: boolean = false;
  constructor(public apiservice: ApiService) {}

  ngOnInit(): void {
    this.isExternal = window.sessionStorage.getItem('appData') ? true : false;
    this.apiservice.errorPage.subscribe((val: error_msg) => {
      if (val) {
        this.errorMsg = val;
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.isExternal) {
      window.parent.postMessage(
        {
          type: 'CALL_ERROR_PAGE_LOADED',
          message: this.errorMsg,
          sessionId: JSON.parse(sessionStorage.getItem('appData'))?.sessionId,
        },
        '*'
      );
    }
  }
}
